export default __webpack_public_path__ + "static/media/js.64d9e0e7.svg";